import request from '@/services/request'

export default {
  getUserDefineRow: {
    url: '/getUserDefineRow',
    method: 'get',
    desc: '获取自定义列'
  },
  editUserDefineRow: {
    url: '/editUserDefineRow',
    method: 'post',
    desc: '编辑自定义列'
  },
  getAmazonCountryInfo: {
    url: '/getAmazonCountryInfo',
    method: 'get',
    desc: '获取亚马逊国家信息'
  },
  getCurrencyInfo: {
    url: '/getCurrencyInfo',
    method: 'post',
    desc: '获取货币信息'
  },
  getShopCountryInfo: {
    url: '/getShopCountryInfo',
    method: 'post',
    desc: '获取下拉关联层级信息'
  },
  getAmazonCountry: {
    url: '/getAmazonCountry',
    method: 'get',
    desc: '获取亚马逊官方站点信息'
  },
  getCountryList: {
    url: '/getCountryList',
    method: 'get',
    desc: '获取站点信息'
  },
  getUTCTime: {
    url: '/getUTCTime',
    method: 'get',
    desc: '获取服务器utc时间'
  },
  getShopCountryTimeZoneInfo: {
    url: '/getShopCountryTimeZoneInfo',
    method: 'post',
    desc: '获取时区map'
  },
  trace: {
    url: '/trace',
    method: 'post',
    desc: '用户访问路径记录'
  },
  switchLanguage: {
    url: '/shop/switchLanguage',
    method: 'get',
    desc: '中英文切换'
  },
  dump: {
    url: '/dump',
    method: 'post',
    desc: '异常上报'
  },
  getAllGoodsClass: {
    url: '/getAllGoodsClass',
    method: 'post',
    desc: '获取所有分类'
  },
  getAllBrand: {
    url: '/getAllBrand',
    method: 'post',
    desc: '获取所有品牌'
  },
  getChargerList: {
    url: '/listing/getChargerList',
    method: 'get',
    desc: '获取运营负责人列表'
  },
  fetchSysNotice: (data = {}, options = {}) => {
    return request(
      {
        url: '/sys/notice/dynamic/latest',
        method: 'post',
        desc: '获取所有费用类型'
      },
      data,
      {
        ignoreCodeHandler: true, // 忽略 ajax拦截器 里面的code处理逻辑
        ...options,
      }
    )
  },
  fetchReceivingCountry: (data = {}, options = {}) => {
    return request(
      {
        url: '/common/country',
        method: 'get',
        desc: '获取收件国家'
      },
      data,
      options
    )
  },
  /**
   * 获取所有的平台字典, 包含线下, 以及平台名称
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchAllPlatformDict: (data = {}, options = {}) => {
    return request(
      {
        url: '/getShopList',
        method: 'post',
        desc: '获取所有的平台字典'
      },
      data,
      options
    )
  },
}
